<template>
  <div class="error-tips-container">
    <van-icon name="close" class="error-icon" />
    <div class="error-text">{{ $lang.askErrorTips }}</div>
  </div>
</template>

<script>
export default {
  created () {
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style lang='less' scoped>
.error-tips-container{
  display: flex;
  align-items: center;
  gap: 10px;
  .error-icon{
    font-size: 20px;
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorTips.vue